export default "__VITE_ASSET__D3aeFSJw__"